export default __webpack_public_path__ + "static/media/LS.69ffce16.svg";